// Função para validar pendências de todos os nós
// Esta função percorre todos os nós e coleta suas pendências individuais

export const validateAllNodesPendencies = (nodes) => {
    const allPendencies = [];

    nodes.forEach(node => {
        const { id, type, data } = node;
        const nodePendencies = [];

        try {
            // Para cada tipo de nó, verifica suas pendências específicas
            switch (type) {
                case 'Decidir':
                    if (!data.dropData?.type && !data.dropData?.data?.value) {
                        nodePendencies.push('Expressão não preenchida');
                    }
                    break;

                case 'Ler':
                    if (!data.variavel) {
                        nodePendencies.push('Variável não selecionada');
                    }
                    if (!data.mensagem?.trim()) {
                        nodePendencies.push('Mensagem não preenchida');
                    }
                    break;

                case 'Mostrar':
                    if (!data.inputValue?.trim()) {
                        nodePendencies.push('Frase não preenchida');
                    }
                    break;

                case 'Atribuir':
                    if (!data.variavel) {
                        nodePendencies.push('Variável não selecionada');
                    }
                    if (!data.dropData?.type && !data.dropData?.data?.value) {
                        nodePendencies.push('Valor não preenchido');
                    }
                    break;

                case 'Visível':
                    if (!data.selectedAvatar) {
                        nodePendencies.push('Avatar não selecionado');
                    }
                    break;

                case 'Posicionar':
                    if (!data.selectedAvatar) {
                        nodePendencies.push('Avatar não selecionado');
                    }
                    break;

                case 'InteragirAvatar':
                    if (!data.selectedAvatar) {
                        nodePendencies.push('Avatar não selecionado');
                    }
                    if (!data.mensagem?.trim()) {
                        nodePendencies.push('Mensagem não preenchida');
                    }
                    if (data.armazenarResposta === "sim" && !data.nomeVariavel?.trim()) {
                        nodePendencies.push('Nome da variável não preenchido');
                    }
                    break;

                case 'Esperar': {
                    const tempo = data.inputValue;
                    if (!tempo || isNaN(tempo) || parseFloat(tempo) <= 0) {
                        nodePendencies.push('Tempo deve ser um número positivo');
                    }
                    break;
                }

                case 'Virar':
                    if (!data.selectedAvatar) {
                        nodePendencies.push('Avatar não selecionado');
                    }
                    if (!data.graus || isNaN(data.graus) || parseFloat(data.graus) <= 0) {
                        nodePendencies.push('Graus deve ser um número positivo');
                    }
                    break;

                case 'Fluxograma':
                    if (data.status === 'aguardando' || !data.fluxogramaData) {
                        nodePendencies.push('Nenhum fluxograma selecionado');
                    }
                    if (data.status === 'erro') {
                        nodePendencies.push('Erro no arquivo selecionado');
                    }
                    break;

                case 'Repetir':
                    console.log('🔍 Validação RepetirNode:', { 
                        nodeId: id, 
                        tipoRepeticao: data.tipoRepeticao, 
                        quantidade: data.quantidade,
                        condicao: data.condicao,
                        dropDataCondicao: data.dropDataCondicao,
                        variavel: data.variavel,
                        valorInicial: data.valorInicial,
                        valorFinal: data.valorFinal,
                        fullData: data
                    });
                    
                    if (!data.tipoRepeticao) {
                        nodePendencies.push('Tipo de repetição não definido');
                    } else {
                        if (data.tipoRepeticao === 'quantidade' && !data.quantidade) {
                            nodePendencies.push('Quantidade de repetições não definida');
                        }
                        if (data.tipoRepeticao === 'condicao') {
                            // Verifica se tem dropDataCondicao válido (operador ou valor direto)
                            const hasDropData = data.dropDataCondicao && (data.dropDataCondicao.type || data.dropDataCondicao.data?.value);
                            if (!hasDropData) {
                                nodePendencies.push('Condição de repetição não definida');
                            }
                        }
                        if (data.tipoRepeticao === 'para' && !data.variavel) {
                            nodePendencies.push('Variável deve ser definida para loop "para"');
                        }
                    }
                    break;

                default:
                    // Para nós não mapeados, não adiciona pendências
                    break;
            }

            // Se o nó tem pendências, adiciona à lista geral
            if (nodePendencies.length > 0) {
                allPendencies.push({
                    nodeId: id,
                    nodeType: type,
                    nodeLabel: data.label || type,
                    pendencies: nodePendencies
                });
            }

        } catch (error) {
            console.warn(`Erro ao validar nó ${id} (${type}):`, error);
        }
    });

    return allPendencies;
};

// Função para formatar as pendências em uma mensagem legível
export const formatPendenciesMessage = (allPendencies) => {
    if (allPendencies.length === 0) {
        return null;
    }

    if (allPendencies.length === 1) {
        const node = allPendencies[0];
        const pendenciesText = node.pendencies.join(', ');
        return `⚠️ Nó "${node.nodeLabel}" tem ${node.pendencies.length === 1 ? 'um aviso' : 'avisos'}: ${pendenciesText}`;
    }

    let message = `⚠️ Encontrados avisos em ${allPendencies.length} nós:\n\n`;
    allPendencies.forEach((node, index) => {
        message += `${index + 1}. Nó "${node.nodeLabel}":\n`;
        node.pendencies.forEach(pendency => {
            message += `   • ${pendency}\n`;
        });
        message += '\n';
    });

    return message.trim();
};